module.exports = __webpack_public_path__ + "img/lecce.f02e58fe.png";